import { render, staticRenderFns } from "./PopularLottery.vue?vue&type=template&id=45f3b8e2&scoped=true"
import script from "./PopularLottery.vue?vue&type=script&lang=js"
export * from "./PopularLottery.vue?vue&type=script&lang=js"
import style0 from "./PopularLottery.vue?vue&type=style&index=0&id=45f3b8e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3b8e2",
  null
  
)

export default component.exports